import { Controller } from "@hotwired/stimulus"

// Single-file drag-and-drop layered over a REAL <input type="file"> that stays the
// submitted field. The input is visually hidden but keyboard-focusable (sr-only) and the
// wrapping <label> opens the picker on click — so mouse, keyboard, and drag-and-drop all
// work, and assistive tech sees a normal labeled file input. The form is multipart, so
// the input (whether filled by the dialog or by a drop) posts normally.
export default class extends Controller {
  static targets = ["input", "dropzone", "filename", "prompt", "clear"]

  connect() { this.render() }

  picked() { this.render() }

  over(e) { e.preventDefault(); this.dropzoneTarget.classList.add("border-primary", "bg-primary/5") }
  leave(e) { e.preventDefault(); this.dropzoneTarget.classList.remove("border-primary", "bg-primary/5") }

  drop(e) {
    e.preventDefault()
    this.leave(e)
    const file = e.dataTransfer.files[0]
    if (!file) return

    const dt = new DataTransfer()
    dt.items.add(file) // one application per upload; ignore any extras
    this.inputTarget.files = dt.files
    this.render()
  }

  clear() {
    this.inputTarget.value = ""
    this.render()
  }

  render() {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = file ? `${file.name} · ${this.humanSize(file.size)}` : ""
      this.filenameTarget.classList.toggle("hidden", !file)
    }
    if (this.hasPromptTarget) this.promptTarget.classList.toggle("hidden", Boolean(file))
    if (this.hasClearTarget) this.clearTarget.classList.toggle("hidden", !file)
  }

  humanSize(bytes) {
    if (bytes < 1024) return `${bytes} B`
    if (bytes < 1048576) return `${Math.round(bytes / 1024)} KB`
    return `${(bytes / 1048576).toFixed(1)} MB`
  }
}
